<template>
  <v-dialog v-model="open" width="600">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <p class="alert-text">{{ message }}</p>
      </v-card-text>
      <v-card-actions>
        <mf-action-buttons
          class="mr-2 pt-2"
          :primary-button="{
            text: 'Fechar',
            action: () => (open = false),
            isVisible: true,
          }"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      open: false,
    }
  },
}
</script>
<style lang="scss">
.alert-text {
  opacity: 0.8;
  font-size: 15px;
  line-height: 1.2;
  letter-spacing: 0.24px;
  text-align: center;
  margin-bottom: 0px !important;
}
</style>
